import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";
import { useSearchParams } from "react-router-dom";

import { ManagedUser } from "types/generated";
import { getSearchQuery } from "components/SearchInput/helpers";

import { sortUsers } from "./sortUsers";

export const useSortedUsers = (users: ManagedUser[], sortDescriptor: SortDescriptor) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  return useMemo(() => {
    let filteredUsers = [...users];
    // Apply search filter if exists
    filteredUsers = filteredUsers.filter((user) =>
      user.username.toLowerCase().includes(searchInput.toLowerCase())
    );

    // Apply sorting if descriptor exists
    if (sortDescriptor.column) {
      filteredUsers = sortUsers(filteredUsers, sortDescriptor);
    }

    return filteredUsers;
  }, [users, searchInput, sortDescriptor]);
};
